import React from 'react';

/**
 * @typedef {Object} RowData
 * @property {string} label
 * @property {string} labelfor
 * @property {string} tooltip
 * @property {string} display
 * @property {boolean} required
 * @property {React.ReactElement} children
 */

/**
 * 
 * @param {RowData} propsObj
 * @returns 
 */

const Row = ({
  display,
  label,
  labelfor,
  tooltip,
  required,
  children
}) => {

  return (
    <div className="p-grid small-margin-bottom-10" style={{ display }}>
      <div className="p-col-12 p-sm-12 p-md-3 p-lg-3 p-mt-2 small-margin-top-0 small-padding-bottom-0">

        {!tooltip &&
          <label htmlFor={labelfor}>{label}</label>
        }

        {tooltip &&
          <label
            className="adpositiontooltip after"
            data-pr-tooltip={tooltip}
            htmlFor={labelfor}>
              {label}
          </label>
        }

        {required &&
          <label style={{ color: 'red' }}>*</label>
        }

      </div>
      <div className="p-col-12 p-sm-12 p-md-9 p-lg-9">
        {children}
      </div>
    </div>
  );
}
export default Row;
